export default __webpack_public_path__ + "static/diasorin-logo-9570c31702d365df1682eac338ea11c3.png";